<template>
    <div v-if="filterDataSource" class="p-relative">
        <Toolbar :is-list="true" v-on:toolbar-button-click="onToolbarClick">
            <SearchPanel v-model="search" :has-filter="false" />
        </Toolbar>
        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="year"
        >
        </FilterPanel>
        <v-row no-gutters>
            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="rowClick"
                >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.header`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.header">
                                    {{item.header}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.doctype`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.doctype">
                                    {{item.doctype}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.countername`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.countername">
                                    {{item.countername}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.lifeperiod`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.lifeperiod">
                                    {{item.lifeperiod}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';

export default {
    name: "Nomenclatures",
    columnIndex: {
        'code': 2,
        'header': 3,
        'doctype': 4,
        'countername': 5,
        'lifeperiod': 6
    },
    components: {
        Toolbar,
        FilterPanel,
        SearchPanel
    },
    props: {
        enterpriseId: {
            type: String,
            default: null
        }
    },
    computed: {
        headers() {
            return [
                { text: this.$t("Индекс"), value: 'code', width: '150px' },
                { text: this.$t("Наименование"), value: 'header' },
                { text: this.$t("Тип_документа"), value: 'doctype', width: '10%' },
                { text: this.$t("Журнал"), value: 'countername', width: '10%'},
                { text: this.$t("Срок"), value: 'lifeperiod', width: '10%'}
            ];
        },
        year: {
            get: function() {
                return this.$store.getters['global/configuration/nomenclatures/getYear'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/nomenclatures/SET_YEAR', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['global/configuration/nomenclatures/getTableSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('global/configuration/nomenclatures/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('global/configuration/nomenclatures/SET_TABLE_SEARCH', v);
            }, 500)
        },
        options: {
            get: function() {
                return this.$store.getters['global/configuration/nomenclatures/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/nomenclatures/SET_TABLE_OPTION', newValue);
            }
        },
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                Year : this.year
            }
        },
    },
    data: () => ({
        filterDataSource: null,
        prevTableFilterObject: null,
        loading: false,
        total: 0,
        entities: [],
        paginationPageCount: 0
    }),
    methods: {
        ...mapActions(['setOverlayVisible']),
        onToolbarClick(e, btn) {
            let action = this[btn.Action];

            if (typeof action !== 'function') {
                this.$notify.alert(`Действие ${btn.Action} не реализовано`);
                return;
            }

            action(btn);
        },
        async Refresh() {
            await this.getData(true);
        },
        async rowClick(e, row) {
            this.setOverlayVisible({ visible: true });
            await this.$router.push({ name: 'NomenclatureCard', query: { id: row.item.id, common: false }, params: { id: row.item.id, common: false }});
            this.setOverlayVisible({ visible: false });
        },
        async getData(isRefresh = false) {
            let filterJson = this.getSerializedFilter();
            let newFilterObj = JSON.parse(filterJson);

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, newFilterObj))
                return;
            
            this.prevTableFilterObject = newFilterObj;
            this.total = 0;
            this.loading = true;

            let response = await httpAPI({
                url: `api/configuration/list?collection=Chancellery.Nomenclature&filter=${this.getSerializedFilter()}`,
                method: 'GET'
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
        },
        getSerializedFilter() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, Year } = this.filter;

            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "code" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 2;

            return JSON.stringify({ SearchStr, Year: !Year || Year === "All" ? "" : Year, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
    },
    watch: {
        filter: {
            handler() {
                this.getData();
            },
            deep: true
        },
    },
    async created() {
        this.setOverlayVisible({ visible: true });
        
        let fakeMenu =
        [
            { Action: "Refresh", Icon: "refresh", Items: null, Text: "Обновить", ToolTip: "Обновить_форму", Type: null, Localize: true }
        ];

        this.$store.commit('documents/toolbar/SET_MENU', { menu: fakeMenu });

        let response = await httpAPI({
            url: `api/configuration/filter?collection=Chancellery.Nomenclature`,
            method: 'GET'
        });

        let years = response?.data.Payload?.Years?.filter(x => x[0] !== '-1').map(x => parseInt(x[0])) ?? [];
        let sortedYears = _(years).sortBy().value().reverse();        
        let filterObject = { Filter: { Title: this.$t("Год"), Default: sortedYears[0], Items: [] } };

        for (let year of sortedYears) {
            filterObject.Filter.Items.push(({ Name: year, Count: -1, Value: String(year), HasItems: false, Requires: null, Items: null }));
        }

        this.filterDataSource = filterObject;
        this.setOverlayVisible({ visible: false });
    }
}
</script>